import { render, staticRenderFns } from "./MediaLibraryPage.vue?vue&type=template&id=3ad876f1&"
import script from "./MediaLibraryPage.vue?vue&type=script&lang=ts&"
export * from "./MediaLibraryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports